import { create } from 'zustand';
import { throttle } from 'lodash';
import { temporal, type TemporalState } from 'zundo';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { createCanvasStore } from './canvas';
import type { AllStoreType } from './imageEditor.type';
import { createPresetStore } from './preset';

const createImageEditorStoreImd = create<AllStoreType>()(
  temporal(
    (...props) => ({
      // @ts-expect-error zustand/traditional
      ...createCanvasStore(...(props as any)),
      // @ts-expect-error zustand/traditional
      ...createPresetStore(...(props as any)),
    }),
    {
      partialize: (state) => ({
        imageUrl: state.imageUrl,
        lines: state.lines,
        currentLine: state.currentLine,
        layerRef: state.layerRef,
        brushSize: state.brushSize,
        brushType: state.brushType,
      }),
      handleSet: (hs) =>
        throttle((pastState) => {
          // Only create history entry if something other than brushSize changed
          if (
            pastState &&
            Object.keys(pastState).some((key) => key !== 'brushSize')
          ) {
            hs(pastState);
          }
        }, 1000),
    }
  )
);

export const createImageEditorStore = () => createImageEditorStoreImd;

function useTemporalStore(): TemporalState<AllStoreType>;

function useTemporalStore<T>(
  selector: (state: TemporalState<AllStoreType>) => T
): T;

function useTemporalStore<T>(
  selector: (state: TemporalState<AllStoreType>) => T,
  equality: (a: T, b: T) => boolean
): T;

function useTemporalStore<T>(
  selector?: any,
  equality?: (a: T, b: T) => boolean
) {
  return useStoreWithEqualityFn(
    createImageEditorStoreImd.temporal,
    selector,
    equality
  );
}

export { useTemporalStore };
